// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"acd9268b","404":"c73c48ac","498":"ce914fbc","513":"8aba3008","566":"1a7c499a","787":"0fbc604e"}[chunkId] + ".chunk.js";
};